exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".CardInput {\n  width: 100%;\n  height: 50px;\n  background-color: #FFFFFF;\n  border-color: #FFFFFF;\n  border-radius: 3px;\n  border-style: solid;\n  text-align: center;\n  font-family: 'Roboto';\n  font-size: 28px;\n  text-transform: uppercase;\n  color: #212121; }\n  .CardInput::placeholder {\n    color: #EBEBEB; }\n", ""]);

